module.exports = __webpack_public_path__ + "img/ro.a197cdde.svg";